export default __webpack_public_path__ + "static/media/NAPD_round-logo.65631a51.jpeg";